import { Injectable } from '@angular/core';
import { LayoutModel } from './layout.model';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  private fallbackLogo = './assets/images/logos/pay_filled.svg';
  public static logo = './assets/images/logos/pay_filled.svg';
  public static color = '#585fff';
  public static text = 'login-page.header.name';

  setThemeBasedOnLayout(layout?: LayoutModel) {
    if (!layout) {
      return;
    }

    if (layout.text) {
      ThemeService.text = layout.text;
    }

    if (layout.logo) {
      ThemeService.logo = layout.logo;
    } else {
      ThemeService.logo = this.fallbackLogo;
    }

    let color = layout.color;
    if (color === '') {
      color = '#585fff';
    }

    ThemeService.color = color;
    document.documentElement.style.setProperty('--primary-color-100', color);
    document.documentElement.style.setProperty('--primary-color-110', this.adjustColorBrightness(color, -10));
    document.documentElement.style.setProperty('--primary-color-130', this.adjustColorBrightness(color, -30));
    document.documentElement.style.setProperty('--primary-color-150', this.adjustColorBrightness(color, -50));
    document.documentElement.style.setProperty('--primary-color-190', this.adjustColorBrightness(color, -90));
  }

  private adjustColorBrightness(hex: string, percent: number): string {
    hex = hex.replace('#', '');

    let r = parseInt(hex.slice(0, 2), 16);
    let g = parseInt(hex.slice(2, 4), 16);
    let b = parseInt(hex.slice(4, 6), 16);

    // Adjust brightness
    if (percent < 0) {
      r = Math.floor(r * (1 + percent / 100));
      g = Math.floor(g * (1 + percent / 100));
      b = Math.floor(b * (1 + percent / 100));
    } else {
      r = Math.floor(r * (1 - percent / 100) + 255 * (percent / 100));
      g = Math.floor(g * (1 - percent / 100) + 255 * (percent / 100));
      b = Math.floor(b * (1 - percent / 100) + 255 * (percent / 100));
    }

    r = Math.min(255, Math.max(0, r));
    g = Math.min(255, Math.max(0, g));
    b = Math.min(255, Math.max(0, b));

    return `#${((r << 16) | (g << 8) | b).toString(16).padStart(6, '0')}`;
  }
}
